<template>


  <div class="category" :class="this.cssClass">

    <div class="category__sorter"></div>

    <div class="category__title">
    <editable-td
            :initValue="this.title"
            @input="titleChanged"></editable-td>
    </div>

    <div class="category__date">
      <flat-pickr v-model="date" :config="config" class="flat-picker-input"></flat-pickr>
    </div>
  </div>

</template>

<script type="text/javascript">
  export default {
    name: 'editable-cat',
    props: {
      id: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
        default: '',
      },
      initDate: {
        type: String,
        required: false,
        default: '27.12.2017',
      },
      selected: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      cssClass() {
        return this.selected ? 'category--selected' : '';
      },
    },
    methods: {
      titleChanged(input) {
        this.$emit('titleChanged', { id: this.id, title: input });
      },
    },
    data() {
      return {
        date: this.initDate,
        config: {
          altFormat: 'd.m.Y',
          altInput: true,
          dateFormat: 'd.m.Y',
        },
      };
    },
  };
</script>

<style type="text/css" lang="less">



  .category{
    height: 34px;
    font-size: 0;
    color:#2F2F2F;

    .flat-picker-input{
      height: 34px;
      line-height: 34px;
    }

    &--selected{
      background: #3F6FA7;
      color:#fff;

      .flat-picker-input{
        color:#fff;
      }
    }

    &__sorter{
      width: 54px;
      height: 34px;
      display: inline-block;
      vertical-align: top;

      background: url('/static/drag.svg') no-repeat;
      background-position: right 20px center;

      cursor: pointer;
    }

    &__title{
      position: relative;
      display: inline-block;
      vertical-align: top;
      width: 240px;
      height: 34px;
      font-size: 14px;
      line-height: 34px;
      margin-right: 16px;
     }


    &__date{
      display: inline-block;
      width: 70px;
      vertical-align: top;
    }




  }

</style>


// WEBPACK FOOTER //
// CatEdit.vue?56095984